import React from 'react';
import { Button } from 'react-bootstrap';

const WinDetailCell = (props) => {
    const winnerInfo = props.winnerInfo;
    const odds = props.odds;
    const selectionId = parseInt(props.selectionId, 10);

    let winner = '-';
    if (winnerInfo && winnerInfo.winner) {
        if (winnerInfo.winner === selectionId) {
            winner = 'W';
        } else if (winnerInfo.places && winnerInfo.places.includes(selectionId)) {
            winner = 'P';
        } else if (odds && odds.status === 'REMOVED') {
            winner = 'NR';
        } else {
            winner = 'L';
        }
    }

    if (winner === 'W') {
        return <Button size="sm" style={{ padding: '0px 4px' }} variant="success">W</Button>
    } else if (winner === 'L') {
        return <Button size="sm" style={{ padding: '0px 4px' }} variant="danger">L</Button>
    } else if (winner === 'P') {
        return <Button size="sm" style={{ padding: '0px 4px' }} variant="warning">P</Button>
    } else if (winner === 'NR') {
        return <Button size="sm" style={{ padding: '0px 4px', color: 'black' }} variant="secondary">NR</Button>
    }
    return <>{winner}</>
}

export default WinDetailCell;
